import { render, staticRenderFns } from "./mine_setting.vue?vue&type=template&id=a7be411e&lang=pug&"
import script from "./mine_setting.vue?vue&type=script&lang=js&"
export * from "./mine_setting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports